import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _43d7016c = () => interopDefault(import('../pages/history/index.vue' /* webpackChunkName: "pages/history/index" */))
const _481e8ef8 = () => interopDefault(import('../pages/gp/about.vue' /* webpackChunkName: "pages/gp/about" */))
const _b4b35d04 = () => interopDefault(import('../pages/gp/terms.vue' /* webpackChunkName: "pages/gp/terms" */))
const _f5066368 = () => interopDefault(import('../pages/n/_id.vue' /* webpackChunkName: "pages/n/_id" */))
const _a3f4a764 = () => interopDefault(import('../pages/p/_id.vue' /* webpackChunkName: "pages/p/_id" */))
const _375e5833 = () => interopDefault(import('../pages/sm/_tag/_.vue' /* webpackChunkName: "pages/sm/_tag/_" */))
const _2a16144f = () => interopDefault(import('../pages/ac/_.vue' /* webpackChunkName: "pages/ac/_" */))
const _50951ee9 = () => interopDefault(import('../pages/f/_.vue' /* webpackChunkName: "pages/f/_" */))
const _00462136 = () => interopDefault(import('../pages/s/_.vue' /* webpackChunkName: "pages/s/_" */))
const _4d965cf7 = () => interopDefault(import('../pages/station/_.vue' /* webpackChunkName: "pages/station/_" */))
const _7d62e5e9 = () => interopDefault(import('../pages/summary/_.vue' /* webpackChunkName: "pages/summary/_" */))
const _33564a05 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/history/",
    component: _43d7016c,
    pathToRegexpOptions: {"strict":true},
    name: "history"
  }, {
    path: "/gp/about/",
    component: _481e8ef8,
    pathToRegexpOptions: {"strict":true},
    name: "gp-about"
  }, {
    path: "/gp/terms/",
    component: _b4b35d04,
    pathToRegexpOptions: {"strict":true},
    name: "gp-terms"
  }, {
    path: "/n/:id?/",
    component: _f5066368,
    pathToRegexpOptions: {"strict":true},
    name: "n-id"
  }, {
    path: "/p/:id?/",
    component: _a3f4a764,
    pathToRegexpOptions: {"strict":true},
    name: "p-id"
  }, {
    path: "/sm/:tag?/*/",
    component: _375e5833,
    pathToRegexpOptions: {"strict":true},
    name: "sm-tag-all"
  }, {
    path: "/ac/*/",
    component: _2a16144f,
    pathToRegexpOptions: {"strict":true},
    name: "ac-all"
  }, {
    path: "/f/*/",
    component: _50951ee9,
    pathToRegexpOptions: {"strict":true},
    name: "f-all"
  }, {
    path: "/s/*/",
    component: _00462136,
    pathToRegexpOptions: {"strict":true},
    name: "s-all"
  }, {
    path: "/station/*/",
    component: _4d965cf7,
    pathToRegexpOptions: {"strict":true},
    name: "station-all"
  }, {
    path: "/summary/*/",
    component: _7d62e5e9,
    pathToRegexpOptions: {"strict":true},
    name: "summary-all"
  }, {
    path: "/",
    component: _33564a05,
    pathToRegexpOptions: {"strict":true},
    name: "index"
  }, {
    path: "/s/",
    component: _00462136,
    name: "search_top"
  }, {
    path: "/ac/",
    component: _2a16144f,
    name: "ac_top"
  }, {
    path: "/summary/",
    component: _7d62e5e9,
    name: "summary_top"
  }, {
    path: "/station/",
    component: _4d965cf7,
    name: "station_top"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
